/* eslint-disable */
import React, { FC } from 'react';
import { Divider, InputProps } from 'antd';
import { SaudiFlagIcon } from '~/img';
import { AsYouType } from 'libphonenumber-js';
import LtrInput from './LtrInput';

// Function to remove the prefixes from the phone number
function removePrefix(value: string): string {
  return value.replace(/^(?:\+966|966|00966)/, '');
}

// Function to ensure the number starts with +966 if not already
function ensurePrefix(value: string): string {
  // Check if the value already starts with +966, 966, or 00966
  console.log('zxzxzxzxzx', value);
  if (/^(?:\+966|966|00966)/.test(value)) {
    return value;
  }
  // Add +966 prefix if missing
  return '+966' + value;
}

export function applyMask<V = InputProps['value']>(value: V): V | string {
  if (!value) return '+966';
  if (typeof value !== 'string') return value;

  // Ensure the phone number starts with +966
  const prefixedValue = ensurePrefix(value);

  // Apply the phone number formatting using libphonenumber
  return prefixedValue;
}

const PhoneNumberInput: FC<InputProps> = (props) => {
  const { value, ...rest } = props;
  return <LtrInput prefix={[<SaudiFlagIcon />, ' ']} value={applyMask(value)} {...rest} />;
};

export default PhoneNumberInput;
